import { useParams } from 'react-router-dom';

import { useGetProductFullView } from 'hooks/product-full/hooks';

/**
 ** OVERLAY - check is product overlay
 * @returns
 */
export const useCheckIsProductOverlay = ({
  productId: productIdProp,
  productFull: productFullProps,
  ...restProps
} = {}) => {
  const { id } = useParams();

  const { productFull: productOverlayDetail } = useGetProductOverlay({
    productId: productIdProp ?? id,
    ...restProps,
  });

  const isProductOverlay = () => {
    if (productIdProp || id) return productOverlayDetail?.isOverlayProduct;

    if (productFullProps) return productFullProps?.isOverlayProduct;

    return false;
  };

  return isProductOverlay();
};

export const useGetProductOverlay = ({
  productId: productIdProp,
  ...restProps
} = {}) => {
  const { id } = useParams();

  const { productFull } = useGetProductFullView({
    productId: productIdProp ?? id,
    ...restProps,
  });

  return {
    originalProductId: productFull?.originalProductId ?? null,
    productFull,
  };
};
